'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Cookies = _interopDefault(require('js-cookie'));

var errors = {
  StoreServiceError: "StoreServiceError",
  StoreFormatError: "StoreFormatError",
  StoreNotFoundError: "StoreNotFoundError",
  CacheError: "CacheError",
  InvalidArgumentError: "InvalidArgumentError"
};
var invalidArgumentError = function invalidArgumentError(message) {
  return {
    type: errors.InvalidArgumentError,
    message: message
  };
};

var getGenderByFloorId = function getGenderByFloorId(floorId) {
  switch (Number(floorId)) {
    case 1000:
      return "women";
    case 1001:
      return "men";
    default:
      return "default";
  }
};
var getFloorIdByGender = function getFloorIdByGender(gender) {
  if (typeof gender !== "string") {
    return null;
  }
  switch (gender.toLowerCase()) {
    case "women":
      return 1000;
    case "men":
      return 1001;
    default:
      return null;
  }
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var oneYearInDays = 365;
var getCookieValue = function getCookieValue(cookieName) {
  return Cookies.get(cookieName) || undefined;
};
var setCookieValue = function setCookieValue(cookieName, value, options) {
  var defaultOptions = {
    expires: oneYearInDays
  };
  Cookies.set(cookieName, value, _objectSpread(_objectSpread({}, defaultOptions), options));
};
var findKeyValuePair = function findKeyValuePair(values, key) {
  return values ? values.split("&").filter(function (keyValue) {
    return keyValue.includes("".concat(key, "="));
  })[0] : null;
};
var concatenateKeyValuePairs = function concatenateKeyValuePairs(cookieValue, newKey, newValue) {
  if (cookieValue) {
    var keyValueInCookie = findKeyValuePair(cookieValue, newKey);
    if (keyValueInCookie) {
      return cookieValue.replace(keyValueInCookie, "".concat(newKey, "=").concat(newValue));
    } else {
      return "".concat(cookieValue, "&").concat(newKey, "=").concat(newValue);
    }
  }
  return "".concat(newKey, "=").concat(newValue);
};
var setKeyedCookieValue = function setKeyedCookieValue(cookieName, key, value) {
  var expires = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : oneYearInDays;
  setCookieValue(cookieName, concatenateKeyValuePairs(getCookieValue(cookieName), key, value), {
    expires: expires
  });
};
var getKeyedCookieValue = function getKeyedCookieValue(cookieName, key) {
  var keyValuePair = findKeyValuePair(getCookieValue(cookieName), key);
  return keyValuePair ? keyValuePair.split("=")[1] : null;
};

var cookiesMap = {
  BrowseCountryKey: "browseCountry",
  FloorCookieName: "floor",
  AsosCookieName: "asos",
  CurrencyCookieName: "currency",
  CurrencyIdKey: "currencyid",
  CurrencyLabelKey: "currencylabel",
  SizeSchemaKey: "sizeSchema",
  PreferredSiteKey: "PreferredSite",
  TopCatIdKey: "topcatid",
  BrowseCurrencyKey: "browseCurrency",
  BrowseLanguageKey: "browseLanguage",
  BrowseSizeSchemaKey: "browseSizeSchema",
  StoreCodeKey: "storeCode",
  TemplateVersionKey: "siteChromeVersion",
  KeyStoreDataversionKey: "keyStoreDataversion",
  GeoCountryKey: "geocountry",
  AffiliateCookieName: "asosAffiliate",
  AffiliateKey: "affiliateId",
  XSiteOrigin: "x-site-origin",
  CtaRef: "ctaRef"
};

function removeSubdomain(hostname) {
  var hostnameSplit = hostname.split(".");
  hostnameSplit[0] = "";
  return hostnameSplit.join(".");
}

/* global window */
var BrowseCountryKey = cookiesMap.BrowseCountryKey,
  FloorCookieName = cookiesMap.FloorCookieName,
  AsosCookieName = cookiesMap.AsosCookieName,
  CurrencyCookieName = cookiesMap.CurrencyCookieName,
  CurrencyIdKey = cookiesMap.CurrencyIdKey,
  CurrencyLabelKey = cookiesMap.CurrencyLabelKey,
  SizeSchemaKey = cookiesMap.SizeSchemaKey,
  PreferredSiteKey = cookiesMap.PreferredSiteKey,
  TopCatIdKey = cookiesMap.TopCatIdKey,
  BrowseCurrencyKey = cookiesMap.BrowseCurrencyKey,
  BrowseLanguageKey = cookiesMap.BrowseLanguageKey,
  BrowseSizeSchemaKey = cookiesMap.BrowseSizeSchemaKey,
  StoreCodeKey = cookiesMap.StoreCodeKey,
  TemplateVersionKey = cookiesMap.TemplateVersionKey,
  GeoCountryKey = cookiesMap.GeoCountryKey,
  KeyStoreDataversionKey = cookiesMap.KeyStoreDataversionKey,
  AffiliateCookieName = cookiesMap.AffiliateCookieName,
  AffiliateKey = cookiesMap.AffiliateKey,
  XSiteOrigin = cookiesMap.XSiteOrigin,
  CtaRef = cookiesMap.CtaRef;
var defaultCurrency = -1;
var thirtyDays = 30;
var inOneHour = 1 / 24;
var inOneMinute = 1 / 1440;
var getBrowseCountry = function getBrowseCountry() {
  return getCookieValue(BrowseCountryKey);
};
var setBrowseCountry = function setBrowseCountry(country) {
  Cookies.remove(BrowseCountryKey);
  var domain = removeSubdomain(window.location.hostname);
  return setCookieValue(BrowseCountryKey, country, {
    domain: domain
  });
};
var getCurrency = function getCurrency() {
  var currencyId = getKeyedCookieValue(AsosCookieName, CurrencyIdKey);
  var currencyLabel = getKeyedCookieValue(AsosCookieName, CurrencyLabelKey);
  return {
    currencyId: parseInt(currencyId) || defaultCurrency,
    currencyLabel: currencyLabel
  };
};
var setCurrency = function setCurrency(_ref) {
  var currencyCode = _ref.currencyCode,
    currencyId = _ref.currencyId;
  if (!currencyId || isNaN(currencyId)) throw invalidArgumentError("Invalid argument: currencyId needs to be a number");
  if (!currencyCode) throw invalidArgumentError("Invalid argument: currencyCode cannot be empty");
  setKeyedCookieValue(AsosCookieName, CurrencyIdKey, currencyId);
  setKeyedCookieValue(AsosCookieName, CurrencyLabelKey, currencyCode);

  // legacy cookie
  setCookieValue(CurrencyCookieName, currencyId);
};
var getSizeSchema = function getSizeSchema() {
  return getKeyedCookieValue(AsosCookieName, SizeSchemaKey);
};
var setSizeSchema = function setSizeSchema(sizeSchema) {
  if (!sizeSchema) {
    throw invalidArgumentError("Invalid argument: sizeSchema cannot be empty");
  }
  setKeyedCookieValue(AsosCookieName, SizeSchemaKey, sizeSchema);
};
var getFloor = function getFloor() {
  return getGenderByFloorId(getCookieValue(FloorCookieName));
};
var setFloor = function setFloor(gender) {
  if (!gender) {
    throw invalidArgumentError("Invalid argument: gender cannot be empty");
  }
  var floorId = getFloorIdByGender(gender);
  if (floorId) {
    setCookieValue(FloorCookieName, floorId);
    setKeyedCookieValue(AsosCookieName, TopCatIdKey, floorId);
  }
};
var getPreferredSite = function getPreferredSite() {
  return getKeyedCookieValue(AsosCookieName, PreferredSiteKey);
};
var isFirstVisit = function isFirstVisit() {
  return !getBrowseCountry();
};
var clearCookies = function clearCookies() {
  setCookieValue(AsosCookieName, "");
  Cookies.remove(FloorCookieName);
  Cookies.remove(AffiliateCookieName);
};
var setBrowseCurrency = function setBrowseCurrency(val) {
  return setCookieValue(BrowseCurrencyKey, val);
};
var setBrowseLanguage = function setBrowseLanguage(val) {
  return setCookieValue(BrowseLanguageKey, val);
};
var setBrowseSizeSchema = function setBrowseSizeSchema(val) {
  return setCookieValue(BrowseSizeSchemaKey, val);
};
var setStoreCode = function setStoreCode(val) {
  return setCookieValue(StoreCodeKey, val);
};
var setTemplateVersion = function setTemplateVersion(storeCode, val) {
  var expiresInDays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : inOneHour;
  return setKeyedCookieValue(TemplateVersionKey, storeCode, val, expiresInDays);
};
var setTemplateVersions = function setTemplateVersions(templateVersions) {
  var expiresInDays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : inOneHour;
  var keyValuePairs = Object.keys(templateVersions).sort().map(function (storeCode) {
    return storeCode + "=" + templateVersions[storeCode];
  }).join("&");
  setCookieValue(TemplateVersionKey, keyValuePairs, {
    expires: expiresInDays
  });
};
var setKeyStoreDataversion = function setKeyStoreDataversion(val) {
  Cookies.remove(KeyStoreDataversionKey);
  var domain = removeSubdomain(window.location.hostname);
  setCookieValue(KeyStoreDataversionKey, val, {
    domain: domain,
    expires: inOneHour
  });
};
var getBrowseCurrency = function getBrowseCurrency() {
  return getCookieValue(BrowseCurrencyKey);
};
var getBrowseLanguage = function getBrowseLanguage() {
  return getCookieValue(BrowseLanguageKey);
};
var getBrowseSizeSchema = function getBrowseSizeSchema() {
  return getCookieValue(BrowseSizeSchemaKey);
};
var getStoreCode = function getStoreCode() {
  return getCookieValue(StoreCodeKey);
};
var getTemplateVersion = function getTemplateVersion(storeCode) {
  return getKeyedCookieValue(TemplateVersionKey, storeCode);
};
var getKeyStoreDataversion = function getKeyStoreDataversion() {
  return getCookieValue(KeyStoreDataversionKey);
};
var getGeoCountry = function getGeoCountry() {
  return getCookieValue(GeoCountryKey);
};
var setAffiliateId = function setAffiliateId(val) {
  return setKeyedCookieValue(AffiliateCookieName, AffiliateKey, val, thirtyDays);
};
var getAffiliateId = function getAffiliateId() {
  return getKeyedCookieValue(AffiliateCookieName, AffiliateKey);
};
var initAsosCookie = function initAsosCookie() {
  if (!getCookieValue(AsosCookieName) && getCookieValue(AsosCookieName) !== "") {
    setCookieValue(AsosCookieName, "");
  }
};
var getXSiteOriginCookieValue = function getXSiteOriginCookieValue() {
  return getCookieValue(XSiteOrigin);
};
var getCtaRef = function getCtaRef() {
  return getCookieValue(CtaRef);
};
var setCtaRef = function setCtaRef(value) {
  return setCookieValue(CtaRef, value, {
    expires: inOneMinute
  });
};

/* global window */
function getXSiteOrigin() {
  var query = window.location.search;
  var xsiteOrigin = query.match(/x-site-origin=([^&]*)/i);
  if (xsiteOrigin && xsiteOrigin[1]) {
    return xsiteOrigin[1];
  }
  return getXSiteOriginCookieValue();
}

exports.getXSiteOrigin = getXSiteOrigin;
exports.getGenderByFloorId = getGenderByFloorId;
exports.getFloorIdByGender = getFloorIdByGender;
exports.getBrowseCountry = getBrowseCountry;
exports.setBrowseCountry = setBrowseCountry;
exports.getCurrency = getCurrency;
exports.setCurrency = setCurrency;
exports.getSizeSchema = getSizeSchema;
exports.setSizeSchema = setSizeSchema;
exports.getFloor = getFloor;
exports.setFloor = setFloor;
exports.getPreferredSite = getPreferredSite;
exports.isFirstVisit = isFirstVisit;
exports.clearCookies = clearCookies;
exports.setBrowseCurrency = setBrowseCurrency;
exports.setBrowseLanguage = setBrowseLanguage;
exports.setBrowseSizeSchema = setBrowseSizeSchema;
exports.setStoreCode = setStoreCode;
exports.setTemplateVersion = setTemplateVersion;
exports.setTemplateVersions = setTemplateVersions;
exports.setKeyStoreDataversion = setKeyStoreDataversion;
exports.getBrowseCurrency = getBrowseCurrency;
exports.getBrowseLanguage = getBrowseLanguage;
exports.getBrowseSizeSchema = getBrowseSizeSchema;
exports.getStoreCode = getStoreCode;
exports.getTemplateVersion = getTemplateVersion;
exports.getKeyStoreDataversion = getKeyStoreDataversion;
exports.getGeoCountry = getGeoCountry;
exports.setAffiliateId = setAffiliateId;
exports.getAffiliateId = getAffiliateId;
exports.initAsosCookie = initAsosCookie;
exports.getXSiteOriginCookieValue = getXSiteOriginCookieValue;
exports.getCtaRef = getCtaRef;
exports.setCtaRef = setCtaRef;
exports.getKeyedCookieValue = getKeyedCookieValue;
